// 꼬끼오 색상 상수 정의
export const COLORS = {
  // 메인 브랜드 색상
  KKOKKIO_PRIMARY: '#DE4C3C',
  KKOKKIO_SECONDARY: '#9B885B',
  
  // 카카오 관련 색상
  KAKAO_YELLOW: '#FEE500',
  KAKAO_BLACK: '#191919',
  
  // 기본 색상
  WHITE: '#FFFFFF',
  BLACK: '#000000',
  GRAY: '#6E747D',
  LIGHT_GRAY: '#F2F3F5',
  BORDER_GRAY: '#E5E5E5',
  
  // 상태 색상
  SUCCESS: '#2FBB46',
  WARNING: '#FF6B35',
  ERROR: '#FF3B30',
  
  // 투명도
  TRANSPARENT: 'transparent',
};

// 기존 코드와의 호환성을 위한 별칭
export const KKOKKIO_PRIMARY_COLOR = COLORS.KKOKKIO_PRIMARY;
export const KAKAO_YELLOW_COLOR = COLORS.KAKAO_YELLOW;
